import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=666adbc2"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports